export const isBack = {
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("SET_ISBACK", true);
  },
  beforeDestroy() {
    this.$store.commit("SET_ISBACK", false);
  },
};
